import React, { useState, useEffect } from 'react';
import { publicUrl } from '../crm/publicUrl';
import { useParams, useNavigate } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { trackVisit, trackEvent } from '../crm/visitor';
import ContactModal from '../crm/ContactModal';

const API = '/crm-api';
const OFFICE_PHONE = '+91 93806 21606';
const WEBSITE = 'diabetikfootcareindia.com';

// Company social links — shared across all DFC employees (as requested).
const SOCIALS = [
  ['LinkedIn', 'https://linkedin.com/company/diabetik-foot-care-india', '#0a66c2', '<path d="M4.98 3.5A2.5 2.5 0 100 3.51a2.5 2.5 0 004.98 0zM.5 8h4V24h-4zM8 8h3.8v2.2h.05C12.4 8.9 14 8 16 8c4 0 5 2.6 5 6V24h-4v-7.5c0-1.8 0-4.1-2.5-4.1s-2.9 2-2.9 4V24H8z"/>'],
  ['WhatsApp', null, '#25D366', '<path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.2 4.79 1.2 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm5.8 14.13c-.24.68-1.42 1.31-1.95 1.36-.5.05-1.13.07-1.82-.11-.42-.13-.96-.31-1.65-.6-2.9-1.25-4.79-4.17-4.94-4.36-.14-.19-1.18-1.57-1.18-2.99s.75-2.12 1.02-2.41c.26-.29.57-.36.76-.36l.55.01c.18.01.42-.07.65.5.24.58.82 2 .89 2.15.07.14.12.31.02.5l-.28.48-.42.5c-.14.14-.28.29-.12.57.16.28.72 1.18 1.55 1.91 1.06.94 1.95 1.24 2.23 1.38.28.14.44.12.6-.07l.87-1.08c.18-.28.36-.23.6-.14.24.09 1.55.73 1.81.86.26.14.44.21.5.32.06.11.06.64-.18 1.32z"/>'],
  ['Facebook', 'https://facebook.com/DiabetikFootCareIndiaPvtLimited', '#1877f2', '<path d="M22 12a10 10 0 10-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.4v7A10 10 0 0022 12z"/>'],
  ['YouTube', 'https://youtube.com/user/DiabetikFootcare', '#ff0000', '<path d="M23 12s0-3.3-.4-4.8a2.5 2.5 0 00-1.8-1.8C19.3 5 12 5 12 5s-7.3 0-8.8.4A2.5 2.5 0 001.4 7.2C1 8.7 1 12 1 12s0 3.3.4 4.8a2.5 2.5 0 001.8 1.8C4.7 19 12 19 12 19s7.3 0 8.8-.4a2.5 2.5 0 001.8-1.8C23 15.3 23 12 23 12zM9.8 15.3V8.7l5.7 3.3z"/>'],
];

const DESIGNATIONS = {
  'karthik.dfc@dfcindia.in': 'Sales Manager', 'anitha.dfc@dfcindia.in': 'HR Manager',
  'priya.dfc@dfcindia.in': 'Senior Marketing Executive', 'arjun.dfc@dfcindia.in': 'Senior Marketing Executive',
  'deepa.dfc@dfcindia.in': 'Senior Marketing Executive', 'vignesh.dfc@dfcindia.in': 'Junior Marketing Executive',
  'sowmya.dfc@dfcindia.in': 'Junior Marketing Executive', 'ramesh.dfc@dfcindia.in': 'Junior Marketing Executive',
  'divya.dfc@dfcindia.in': 'Junior Marketing Executive', 'suresh.dfc@dfcindia.in': 'Junior Marketing Executive',
};

const WA_PATH = SOCIALS.find((s) => s[0] === 'WhatsApp')[3];

const IC = {
  phone: 'M6.6 10.8a15.5 15.5 0 006.6 6.6l2.2-2.2a1 1 0 011-.24 11.4 11.4 0 003.5.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.2.2 2.4.57 3.5a1 1 0 01-.24 1z',
  mail: 'M4 4h16a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1zm8 7L4.5 6.5v.9L12 12l7.5-4.6v-.9z',
  globe: 'M12 2a10 10 0 100 20 10 10 0 000-20zm6.9 7h-3a15 15 0 00-1.2-3.6A8 8 0 0118.9 9zM12 4c.8 1 1.5 2.3 2 4H10c.5-1.7 1.2-3 2-4zM4.3 14a8 8 0 010-4h3.3a17 17 0 000 4zm.8 2h3a15 15 0 001.2 3.6A8 8 0 015.1 16zM8.1 9h-3a8 8 0 013.6-3.6A15 15 0 008.1 9zM12 20c-.8-1-1.5-2.3-2-4h4c-.5 1.7-1.2 3-2 4zm2.4-6H9.6a15 15 0 010-4h4.8a15 15 0 010 4zm.3 5.6A15 15 0 0015.9 16h3a8 8 0 01-4.2 3.6zM16.4 14a17 17 0 000-4h3.3a8 8 0 010 4z',
  user: 'M12 12a5 5 0 100-10 5 5 0 000 10zm0 2c-5 0-9 2.5-9 5.5V22h18v-2.5c0-3-4-5.5-9-5.5z',
  send: 'M3 11l18-8-8 18-2-7-8-3z',
};
const Svg = ({ d, s = 18, f = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={s} height={s} fill={f}><path d={d} /></svg>
);

const CSS = `
.mc-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;background:#05100e;font-family:'Poppins',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif}
.mc-card{position:relative;width:100%;max-width:400px;border-radius:30px;padding:26px 24px 26px;text-align:center;color:#eaf3ee;
  background:linear-gradient(160deg,#123a2c,#08171d);box-shadow:0 30px 80px rgba(0,0,0,.6),inset 0 1px 0 rgba(255,255,255,.05);border:1px solid rgba(201,162,75,.18)}
.mc-logo img{height:46px;background:#fff;border-radius:13px;padding:6px}
.mc-av{width:300px;height:300px;border-radius:50%;overflow:hidden;margin:16px auto 0;border:3px solid #c9a24b;box-shadow:0 0 0 6px rgba(201,162,75,.14),0 12px 30px rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;background:#0f2b5c}
.mc-av img{width:100%;height:100%;object-fit:cover}
.mc-nm{font-size:34px;font-weight:700;margin-top:14px;color:#fff}
.mc-ti{color:#f0d68a;font-weight:600;font-size:12px;text-transform:uppercase;letter-spacing:2px;margin-top:3px}
.mc-co{color:#cfe3d8;font-size:11.5px;margin-top:3px}
.mc-rows{margin-top:18px;display:flex;flex-direction:column;gap:8px;text-align:left}
.mc-row{position:relative;display:flex;align-items:center;gap:11px;background:rgba(255,255,255,.06);border:1px solid rgba(201,162,75,.22);border-radius:12px;padding:11px 13px;font-size:12.5px;color:#f4fbf7;text-decoration:none;cursor:pointer;transition:border-color .15s}
.mc-row:hover{border-color:rgba(230,198,106,.6)}
.mc-i{width:31px;height:31px;border-radius:9px;flex:none;display:flex;align-items:center;justify-content:center;color:#0e2a20;background:linear-gradient(135deg,#e6c66a,#c9a24b)}
.mc-tip{position:absolute;left:52px;top:50%;transform:translateY(-50%) scale(.9);background:#0b1512;color:#fff;font-weight:700;font-size:13px;padding:7px 16px;border-radius:9px;white-space:nowrap;opacity:0;pointer-events:none;transition:.15s;box-shadow:0 10px 22px rgba(0,0,0,.55);z-index:7}
.mc-row:hover .mc-tip{opacity:1;transform:translateY(-50%) scale(1)}
.mc-cap{margin-top:22px;color:#f0d68a;font-weight:700;font-size:12px;letter-spacing:2px}
.mc-qr{width:166px;height:166px;margin:12px auto 0;padding:16px;background:linear-gradient(160deg,#123a2c,#0c2119);border:1px solid rgba(201,162,75,.3);border-radius:16px;box-shadow:0 0 30px rgba(201,162,75,.16),inset 0 0 20px rgba(0,0,0,.4)}
.mc-qr svg{width:100%;height:100%;display:block}
.mc-sub{font-size:11px;color:#cfe3d8;margin-top:9px}
.mc-tray{display:flex;flex-wrap:wrap;justify-content:center;gap:14px 6px}
.mc-tray.r2{margin-top:14px}
.mc-item{display:flex;flex-direction:column;align-items:center;gap:7px;width:52px;cursor:pointer;text-decoration:none}
.mc-ci{width:44px;height:44px;border-radius:14px;display:flex;align-items:center;justify-content:center;box-shadow:0 5px 12px rgba(0,0,0,.35);transition:transform .12s}
.mc-item:active .mc-ci{transform:translateY(3px)}
.mc-lb{font-size:9px;color:#cfe3d8;font-weight:600;text-align:center;line-height:1.1}
.mc-gold .mc-ci{background:linear-gradient(145deg,#f4dc95,#cba53f);box-shadow:0 5px 0 #94722c,0 10px 16px rgba(201,162,75,.35),inset 0 1px 0 rgba(255,255,255,.6)}
.mc-gold .mc-lb{color:#f0d68a}
.mc-foot{text-align:center;font-size:13px;font-weight:600;color:#e8f4ee;margin-top:22px;letter-spacing:.5px}

/* Charcoal colourway (User.cardTheme = 'charcoal'). Overrides only the green
   surfaces — the gold accents, layout and type scale stay as the house style,
   so a grey card still reads as the same family. Scoped to .mc-charcoal, which
   is only ever set on the card page, never the microsite. */
.mc-charcoal.mc-wrap{background:#0b0b0d}
.mc-charcoal .mc-card{background:linear-gradient(160deg,#2b2d31,#151619)}
.mc-charcoal .mc-av{background:#1f2125}
.mc-charcoal .mc-co{color:#d5d9df}
.mc-charcoal .mc-i{color:#1b1c1f}
.mc-charcoal .mc-tip{background:#17181b}
.mc-charcoal .mc-qr{background:linear-gradient(160deg,#2b2d31,#141518)}
.mc-charcoal .mc-sub{color:#d5d9df}
.mc-charcoal .mc-lb{color:#d5d9df}
.mc-charcoal .mc-foot{color:#f0f2f5}
`;

export default function LandingPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [emp, setEmp] = useState(null);
  const [status, setStatus] = useState('loading');
  const [contactOpen, setContactOpen] = useState(false);

  useEffect(() => {
    fetch(`${API}/public/employee/${slug}`).then((r) => r.json()).then((d) => {
      if (d.success && d.employee) { setEmp(d.employee); setStatus('ok'); }
      else setStatus('notfound');
    }).catch(() => setStatus('notfound'));
    trackVisit(slug, 'card'); // CRM: log visitor + session
    const qr = new URLSearchParams(window.location.search).get('qr');
    trackEvent(qr ? 'qr_scan' : 'page_view', qr ? 'Scanned QR on card' : 'Opened digital card', { employeeSlug: slug, source: 'card' });
  }, [slug]);

  if (status === 'loading') return <div className="mc-wrap"><style>{CSS}</style><div style={{ color: '#e6c66a' }}>Loading…</div></div>;
  if (status === 'notfound') return <div className="mc-wrap"><style>{CSS}</style><div style={{ color: '#dfeee7', textAlign: 'center' }}><h1 style={{ fontSize: 22, fontWeight: 700 }}>Profile Not Found</h1><p style={{ color: '#9fc0b2' }}>/{slug}</p></div></div>;

  const designation = (emp.designation && emp.designation.trim()) || DESIGNATIONS[(emp.email || '').toLowerCase()] || 'Team Member';
  const initials = emp.name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase();
  const micrositeUrl = publicUrl(`/microsite/${slug}`); // QR opens the microsite

  // Charcoal is the house look (matches the printed card back). An employee can
  // still opt back to the original green by setting cardTheme = 'green'.
  return (
    <div className={`mc-wrap${emp.cardTheme === 'green' ? '' : ' mc-charcoal'}`}>
      <style>{CSS}</style>
      <div className="mc-card">
        <div className="mc-logo"><img src="/dfci-logo.png" alt="DFC" /></div>
        <div className="mc-av"><Photo slug={emp.profileSlug} initials={initials} /></div>
        <div className="mc-nm">{emp.name}</div>
        <div className="mc-ti">{designation}</div>
        <div className="mc-co">{emp.company || 'Diabetik Foot Care India'}</div>

        <div className="mc-rows">
          <div className="mc-row" onClick={() => { trackEvent('page_view', 'Opened microsite from card', { employeeSlug: slug, source: 'card' }); navigate(`/microsite/${slug}`); }}>
            <span className="mc-i"><Svg d={IC.globe} s={15} /></span>View my Microsite
          </div>
          <div className="mc-row" onClick={() => { trackEvent('whatsapp_click', 'Clicked Contact Me on card', { employeeSlug: slug, source: 'card' }); setContactOpen(true); }}>
            <span className="mc-i"><Svg d={IC.user} s={15} /></span>Contact Me
          </div>
        </div>

        <div className="mc-cap">◆ Scan for Microsite ◆</div>
        <div className="mc-qr"><QRCodeSVG value={micrositeUrl} size={134} level="M" fgColor="#ffffff" bgColor="transparent" /></div>
        <div className="mc-sub">Scan to view my microsite</div>

        <div className="mc-foot">Powered by TECGSOFT</div>
      </div>

      {contactOpen && <ContactModal slug={slug} whatsapp={emp.whatsapp} onClose={() => setContactOpen(false)} />}
    </div>
  );
}

function Photo({ slug, initials }) {
  const exts = ['jpg', 'jpeg', 'png', 'webp'];
  const [i, setI] = useState(0);
  if (!slug || i >= exts.length) return <span style={{ color: '#fff', fontWeight: 700, fontSize: 130 }}>{initials}</span>;
  return <img src={`/photos/${slug}.${exts[i]}`} alt={initials} onError={() => setI(i + 1)} />;
}
